// @figma file=nq2oTuNpAeyLOoF0tXtO32 node=14860-68939 name="Separator" set="shadcn-studio-pro-v5" verified=2026-03-16

import * as SeparatorPrimitive from '@radix-ui/react-separator';
import * as React from 'react';
import { cn } from '../../lib/utils';

export interface SeparatorProps
  extends React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root> {
  /**
   * Optional label rendered in the center of the separator.
   * Only meaningful when orientation="horizontal".
   */
  label?: React.ReactNode;
}

const Separator = React.forwardRef<
  React.ElementRef<typeof SeparatorPrimitive.Root>,
  SeparatorProps
>(({ className, orientation = 'horizontal', decorative = true, label, ...props }, ref) => {
  if (label && orientation === 'horizontal') {
    return (
      <div className={cn('flex items-center gap-3', className)}>
        <SeparatorPrimitive.Root
          ref={ref}
          decorative={decorative}
          orientation="horizontal"
          className="shrink bg-border h-px flex-1"
          {...props}
        />
        <span className="text-xs text-muted-foreground whitespace-nowrap">{label}</span>
        <SeparatorPrimitive.Root
          decorative={decorative}
          orientation="horizontal"
          className="shrink bg-border h-px flex-1"
        />
      </div>
    );
  }

  return (
    <SeparatorPrimitive.Root
      ref={ref}
      decorative={decorative}
      orientation={orientation}
      className={cn(
        'shrink-0 bg-border',
        orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px',
        className,
      )}
      {...props}
    />
  );
});
Separator.displayName = SeparatorPrimitive.Root.displayName;

export { Separator };
